import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
} from '@mui/material';
import { MonitorHeart as MonitorIcon } from '@mui/icons-material';
import {
  MonitorStatusChip,
  MonitorTimestamps,
  formatMonitorDateTime,
} from '../../../utils/monitorDisplayUtils';

interface MonitorInfoCardProps {
  title?: string;
  status?: string | null;
  timestamps?: MonitorTimestamps;
  showLatencia?: boolean;
  showUltimaVerificacao?: boolean;
  showUltimoPing?: boolean;
}

const MonitorInfoCard: React.FC<MonitorInfoCardProps> = ({
  title = 'Monitoramento',
  status,
  timestamps = {},
  showLatencia = false,
  showUltimaVerificacao = false,
  showUltimoPing = false,
}) => {
  const {
    ultimoOnlineEm,
    ultimoOfflineEm,
    ultimaVerificacaoEm,
    ultimoPingEm,
    latenciaMs,
  } = timestamps;

  return (
    <Card>
      <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h6" sx={{ fontSize: '1rem', display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <MonitorIcon fontSize="small" color="primary" />
            {title}
          </Typography>
          <MonitorStatusChip status={status} />
        </Box>

        <Divider sx={{ mb: 1 }} />

        <Grid container spacing={1}>
          {showLatencia && (
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary" display="block">
                Latência (último ping)
              </Typography>
              <Typography variant="body2" fontWeight="medium">
                {latenciaMs != null ? `${latenciaMs} ms` : '—'}
              </Typography>
            </Grid>
          )}

          {showUltimoPing && (
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary" display="block">
                Último ping
              </Typography>
              <Typography variant="body2">{formatMonitorDateTime(ultimoPingEm)}</Typography>
            </Grid>
          )}

          {showUltimaVerificacao && (
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary" display="block">
                Última verificação
              </Typography>
              <Typography variant="body2">{formatMonitorDateTime(ultimaVerificacaoEm)}</Typography>
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary" display="block">
              Última vez online
            </Typography>
            <Typography variant="body2" color="success.main">
              {formatMonitorDateTime(ultimoOnlineEm)}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary" display="block">
              Última vez offline
            </Typography>
            <Typography variant="body2" color="error.main">
              {formatMonitorDateTime(ultimoOfflineEm)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MonitorInfoCard;
